import { z } from 'zod';

import { requiredString } from '@/utils/zodUtils';

export const PricingTagFormSchema = (t) =>
  z
    .object({
      tag: requiredString(t),
    })
    .strict()
    .required();

export type PricingTagFormType = z.infer<ReturnType<typeof PricingTagFormSchema>>;
